package com.nonopn.skydome.common.app.checkout

import kotlinx.browser.window

private const val AttemptedCodeKey = "strikeradar.checkout.login.code"

actual fun checkoutCurrentQuery(): String = window.location.search

actual fun checkoutReplaceQuery(query: String) {
    val location = window.location
    window.history.replaceState(null, "", location.pathname + query + location.hash)
}

actual fun checkoutAttemptStore(): CheckoutAttemptStore = SessionStorageAttemptStore

// sessionStorage: survives a reload of the tab, not shared with other tabs, cleared with the tab
@Suppress("TooGenericExceptionCaught", "SwallowedException")
private object SessionStorageAttemptStore : CheckoutAttemptStore {
    private val memory = MemoryCheckoutAttemptStore()

    override fun wasAttempted(code: String): Boolean = memory.wasAttempted(code) || try {
        window.sessionStorage.getItem(AttemptedCodeKey) == code
    } catch (_: Throwable) {
        false
    }

    override fun markAttempted(code: String) {
        memory.markAttempted(code)
        try {
            window.sessionStorage.setItem(AttemptedCodeKey, code)
        } catch (_: Throwable) {
            // storage disabled: the in memory guard still protects this page
        }
    }
}
